import { RegionIds } from "configuration/locations"

export type MapViewState = {
    latitude: number
    longitude: number
    zoom: number
    pitch: number
    bearing: number
}

const defaultViewStates = {
    zoom: 5,
    pitch: 0,
    bearing: 0,
    // @todo - when more time, investigate which of these we can use to ensure proper web-mercator initiation from just this object
    // altitude: 0,
    // height: 1247,
    // maxPitch: 60,
    // maxZoom: 20,
    // minPitch: 0,
    // minZoom: 0,
    // normalize: true,
    // width: 1450,
}

export const initialMapViewStates: Record<string, MapViewState> = {
    [RegionIds.NorthAmerica]: {
        ...defaultViewStates,
        longitude: -98.894405,
        latitude: 39.704277,
        zoom: 4,
    },
    [RegionIds.BritishColumbia]: {
        ...defaultViewStates,
        latitude: 50.7853,
        longitude: -121.41669,
    },
    [RegionIds.NorthCarolina]: {
        ...defaultViewStates,
        latitude: 35.759575,
        longitude: -79.019302,
        zoom: 7,
    },
    [RegionIds.Quebec]: {
        ...defaultViewStates,
        latitude: 47.24405026003309,
        longitude: -73.745385729245,
        zoom: 6,
    },
    [RegionIds.Victoria]: {
        ...defaultViewStates,
        latitude: -36.99903148181369,
        longitude: 145.35861285898244,
        zoom: 7.299984531398479,
    },
}
